import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import Input from "../../../../../../components/textbox/Input";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Select from "../../../../../../components/select/Select";
import SelectAutocomplete from "../../../../../../components/selectAutocomplete/SelectAutocomplete";
import Autocomplete from "../../../../../../components/autocomplete/Autocomplete";
import Calendar from "../../../../../../components/calendar/Calendar";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Utils from "../../../../../../utils/Utils";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import ProfessioniEpatiteE from "../../../../../../utils/ProfessioniEpatiteE.json"

class InformazioniSulCaso extends Component {

    state={
        informazioniSulCaso:{ulss:"",
            regione:OggettiUtili.Regioni["050"],
            numeroCasi:"",
            dataIntervista:"",
            cognome:"",
            nome:"",
            sesso:"",
            dataNascita:"",
            professione:"",
            titoloStudio:"",
            cittadinanza:"",
            comune:"",
            anniItalia:"",
            corretto:[]
        },
        regioni :OggettiUtili.Regioni,
        comuni :JSON.parse(sessionStorage.getItem("comuni")),
        comuniPerCodice:JSON.parse((sessionStorage.getItem("comuniPerCodice"))),
        nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        nazioniPerCodice:JSON.parse((sessionStorage.getItem("nazioniPerCodice"))),
        professioni: ProfessioniEpatiteE,
        professioniPerCodice:Utils.arrayToMap(ProfessioniEpatiteE, "codice"),
        mappingProfessioni: OggettiUtili.mappingProfessioniEpatiteE
    }




    constructor(props) {
        super(props);
        this.mapObjectToList=this.mapObjectToList.bind(this);
        this.riceviValoreInput=this.riceviValoreInput.bind(this);
        this.controlloDati=this.controlloDati.bind(this);
        this.pulisciValori=this.pulisciValori.bind(this);
        this.validate=this.validate.bind(this);
    }

    componentDidMount() {

        let newState=this.state.informazioniSulCaso;
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.informazioniSulCaso){
            let informazioniSulCasoCopia=this.props.segnalazioneCopia.schedaSpeciale.informazioniSulCaso;
            newState.ulss=informazioniSulCasoCopia.ulss ? OggettiUtili.ulssMap[informazioniSulCasoCopia.ulss].codice : "";
            newState.numeroCasi=informazioniSulCasoCopia.numeroCasi ? informazioniSulCasoCopia.numeroCasi : "";
            newState.dataIntervista=informazioniSulCasoCopia.dataIntervista ? informazioniSulCasoCopia.dataIntervista : "";
            newState.cognome=informazioniSulCasoCopia.cognome ? informazioniSulCasoCopia.cognome : "";
            newState.nome=informazioniSulCasoCopia.nome ? informazioniSulCasoCopia.nome : "";
            newState.dataNascita=informazioniSulCasoCopia.dataNascita ? informazioniSulCasoCopia.dataNascita : "";
            newState.comune=informazioniSulCasoCopia.comune && this.state.comuniPerCodice[informazioniSulCasoCopia.comune] ? this.state.comuniPerCodice[informazioniSulCasoCopia.comune] : "";
            newState.sesso=informazioniSulCasoCopia.sesso ? informazioniSulCasoCopia.sesso : "";
            newState.cittadinanza=informazioniSulCasoCopia.cittadinanza && this.state.nazioniPerCodice[informazioniSulCasoCopia.cittadinanza] ? this.state.nazioniPerCodice[informazioniSulCasoCopia.cittadinanza] : "";
            newState.anniItalia=informazioniSulCasoCopia.anniItalia ? informazioniSulCasoCopia.anniItalia : "";
            newState.titoloStudio=informazioniSulCasoCopia.titoloStudio ? informazioniSulCasoCopia.titoloStudio : "";
            newState.professione= informazioniSulCasoCopia.professione && this.state.professioniPerCodice[informazioniSulCasoCopia.professione] ? this.state.professioniPerCodice[informazioniSulCasoCopia.professione] : "";
        } else{
            newState.ulss=this.props.segnalazioneCopia && this.props.segnalazioneCopia.ulssSegnalazione ? OggettiUtili.ulssMap[this.props.segnalazioneCopia.ulssSegnalazione].codice : "";
            newState.cognome=this.props.datiPaziente && this.props.datiPaziente.cognomePaziente ? this.props.datiPaziente.cognomePaziente.substring(0,2) : "";
            newState.nome=this.props.datiPaziente && this.props.datiPaziente.nomePaziente ? this.props.datiPaziente.nomePaziente.substring(0,2) : "";
            newState.sesso=this.props.datiPaziente && this.props.datiPaziente.sesso ? this.props.datiPaziente.sesso : "";
            newState.dataNascita=this.props.datiPaziente && this.props.datiPaziente.dataDiNascita ? this.props.datiPaziente.dataDiNascita : "";
            newState.comune=this.props.datiPaziente && this.props.datiPaziente.comuneDomicilio ? this.props.datiPaziente.comuneDomicilio : "";
            newState.cittadinanza=this.props.datiPaziente && this.props.datiPaziente.cittadinanza ? this.props.datiPaziente.cittadinanza : "";
            newState.professione=this.props.datiPaziente && this.props.datiPaziente.professione ? this.state.mappingProfessioni[this.props.datiPaziente.professione] : "";
        }
        this.setState({informazioniSulCaso: newState});
        this.controlloDati();
        let objectForBackend = Object.assign({}, this.createObjectForBackEnd())
        this.props.setStatePadre(newState, "informazioniSulCaso", objectForBackend, this.validate());
    }

    createObjectForBackEnd(){
        let objectForBackEnd={...this.state.informazioniSulCaso};
        objectForBackEnd.comune= objectForBackEnd.comune && objectForBackEnd.comune.codice ? objectForBackEnd.comune.codice : "";
        objectForBackEnd.cittadinanza=objectForBackEnd.cittadinanza && objectForBackEnd.cittadinanza.codice ? objectForBackEnd.cittadinanza.codice : "";
        objectForBackEnd.professione=objectForBackEnd.professione && objectForBackEnd.professione.codice ? objectForBackEnd.professione.codice : "";
        objectForBackEnd.regione= objectForBackEnd.regione && objectForBackEnd.regione.codice ? objectForBackEnd.regione.codice : "";
        let objFinal =Utils.removeFieldFromObject(objectForBackEnd, "corretto")
        return Utils.removeEmptyValueFromObject(objFinal);
    }

    riceviValoreInput(field, event){
        let newState= this.state.informazioniSulCaso;
        if (field && field.target && field.target.id){
            newState[field.target.id]=field.target.value;
        }
        else {
            newState[field]=event.target.value;
        }
        this.pulisciValori(newState);
        this.setState({informazioniSulCaso: newState})
        this.controlloDati();
        let objectForBackend = Object.assign({}, this.createObjectForBackEnd())
        this.props.setStatePadre(newState, "informazioniSulCaso", objectForBackend, this.validate())

    }

    validate() {

        if (this.state.informazioniSulCaso.dataIntervista) {
            let validatedataIntervista = Utils.checkDateInterval(this.state.informazioniSulCaso.dataIntervista, "31/12/1899");
            let validatedataIntervistaOdierna = Utils.checkDateInterval(this.state.informazioniSulCaso.dataIntervista, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataIntervista) {
                return "Messages.DataIntervista"
            } else if (!validatedataIntervistaOdierna) {
                return "Messages.DataIntervistaOdierna"
            }
        }

        if (this.state.informazioniSulCaso.dataNascita) {
            let validatedataNascita = Utils.checkDateInterval(this.state.informazioniSulCaso.dataNascita, "31/12/1899");
            let validatedataNascitaOdierna = Utils.checkDateInterval(this.state.informazioniSulCaso.dataNascita, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataNascita) {
                return "Messages.DataNascita"
            } else if (!validatedataNascitaOdierna) {
                return "Messages.DataNascitaOdierna"
            }
        }


        return ""

    }
    pulisciValori(state){
        if ((state.cittadinanza && state.cittadinanza.codice==="100") || !state.cittadinanza){
            state.anniItalia="";
        }
        return state;

    }

    controlloDati(){
        let informazioniSulCaso=this.state.informazioniSulCaso;
        informazioniSulCaso.corretto=[];

        if (!informazioniSulCaso.ulss)informazioniSulCaso.corretto[0]="Campo \"ULSS\" mancante";
        if (!informazioniSulCaso.nome)informazioniSulCaso.corretto[1]="Campo \"Nome\" mancante";
        if (!informazioniSulCaso.cognome)informazioniSulCaso.corretto[2]="Campo \"Cognome\" mancante";
        if (!informazioniSulCaso.sesso)informazioniSulCaso.corretto[3]="Campo \"Sesso\" mancante";
        if (!informazioniSulCaso.dataNascita ||
           (informazioniSulCaso.dataNascita && (Utils.isDateInValid(Utils.transformDateForBackend(informazioniSulCaso.dataNascita),"-"))))
           informazioniSulCaso.corretto[4]="Campo \"Data di nascita\" mancante o errato";
        if (!informazioniSulCaso.cittadinanza)informazioniSulCaso.corretto[5]="Campo \"Cittadinanza\" mancante";
        if (informazioniSulCaso.dataIntervista && (Utils.isDateInValid(Utils.transformDateForBackend(informazioniSulCaso.dataIntervista), "-")))informazioniSulCaso.corretto[6]="Campo \"Data intervista\" errato";

        this.setState({informazioniSulCaso: informazioniSulCaso});
    }

    mapObjectToList(object){
        let lista = []
        Object.keys(object).map((key) => {
            if (key !== 0 || key !== 99 || key !== 88)
                return lista.push(object[key]);
        })

        return (Utils.sortByKey(lista, "descrizione"));
    }



    render(){
        const {t}=this.props
        return(
            <div>
                <div><h6>Informazioni sul caso</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div>
                        <div className={"row"}>
                            <div className={"col-lg-12 mt-1"}>
                                <div className={"row"}>
                                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello4' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9",marginTop:"10px"}}>
                                            {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.ulss")}
                                            <span className={styles.mandatoryColor}>*</span>
                                        </p>
                                        <SelectAutocomplete
                                            id={"ulss"}
                                            field={"ulss"}
                                            onChange={this.riceviValoreInput}
                                            value={this.state.informazioniSulCaso.ulss}
                                            functionMap={this.mapObjectToList(OggettiUtili.ulssMap).map((oggetto) => {
                                                return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                            })}
                                        />
                                    </div>

                                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello3' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9",marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.regione")}
                                        </p>
                                        <Autocomplete
                                            id={"regione"}
                                            field={"regione"}
                                            keyField={"codice"}
                                            value={this.state.informazioniSulCaso.regione}
                                            descriptionField={"descrizione"}
                                            suggestionField={"descrizione"}
                                            disabled={true}
                                            onChange={this.riceviValoreInput}
                                            placeholder={t("SchedaSpecialeEpatiteE.InformazioniSulCaso.regione")}
                                            suggestions={this.state.regioni}
                                            />
                                    </div>

                                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello2' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9",marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.numeroCaso")}
                                        </p>
                                        <Input id={"numeroCasi"}
                                               onChange={this.riceviValoreInput}
                                               field={"numeroCasi"}
                                               errorMessage={"sezione non valido"}
                                               value={this.state.informazioniSulCaso.numeroCasi}
                                               type={"number"}
                                               min={"0"}
                                               placeholder={"Numero caso"}>
                                        </Input>
                                    </div>
                                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9",marginTop: "10px"}}>
                                           {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.dataIntervista")}
                                        </p>
                                        <Calendar
                                            id={"dataIntervista"}
                                            field={"dataIntervista"}
                                            value={this.state.informazioniSulCaso.dataIntervista}
                                            onChange={this.riceviValoreInput}
                                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                              "Data")}
                                            error={(this.state.informazioniSulCaso.dataIntervista === "" ||
                                             this.state.informazioniSulCaso.dataIntervista == null) ? false :
                                             Utils.isDateInValid(Utils.transformDateForBackend(this.state.informazioniSulCaso.dataIntervista), "-")}
                                        >
                                        </Calendar>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello4' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.cognome")}
                                    <span className={styles.mandatoryColor}>*</span>
                                </p>
                                <Input
                                    id={"cognome"}
                                    onChange={this.riceviValoreInput}
                                    field={"cognome"}
                                    value={this.state.informazioniSulCaso.cognome}
                                    placeholder={t("SchedaSpecialeEpatiteE.InformazioniSulCaso.cognome")}
                                >
                                </Input>
                            </div>
                            <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello3' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.nome")}
                                        <span className={styles.mandatoryColor}>*</span>
                                </p>
                                <Input
                                    id={"nome"}
                                    onChange={this.riceviValoreInput}
                                    field={"nome"}
                                   value={this.state.informazioniSulCaso.nome}
                                    placeholder={t("SchedaSpecialeEpatiteE.InformazioniSulCaso.nome")}
                                >
                                </Input>
                            </div>
                            <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello2' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.dataNascita")}
                                    <span className={styles.mandatoryColor}>*</span>
                                </p>
                                <Calendar
                                    id={"dataNascita"}
                                    field={"dataNascita"}
                                    onChange={this.riceviValoreInput}
                                    value={this.state.informazioniSulCaso.dataNascita}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                        t("Data di nascita"))}
                                    error={(!this.state.informazioniSulCaso.dataNascita) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.informazioniSulCaso.dataNascita), "-")}
                                />

                            </div>
                            <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.sesso")}
                                    <span className={styles.mandatoryColor}>*</span>
                                </p>
                                <div className="row">
                                    <RadioButton id={"sessoM"}
                                                 name={"sesso"} label={"M"}
                                                 value={"M"}
                                                 newRadio={true}
                                        onClick={this.riceviValoreInput}
                                        checked={this.state.informazioniSulCaso.sesso === "M"}
                                    >
                                    </RadioButton>
                                    <RadioButton id={"sessoF"}
                                                 name={"sesso"} label={"F"}
                                                 value={"F"}
                                                 newRadio={true}
                                        onClick={this.riceviValoreInput}
                                        checked={this.state.informazioniSulCaso.sesso === "F"}
                                    >
                                    </RadioButton>
                                </div>
                            </div>
                        </div>

                        <div className={"row"}>
                            <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello3' : ''}`}>
                                <div className={styles.fieldContainer}>
                                    <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                        {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.comune")}
                                    </p>
                                    <Autocomplete
                                        id={"comune"}
                                        keyField={"codice"}
                                        descriptionField={"descrizione"}
                                        suggestionField={"descrizione"}
                                        onChange={this.riceviValoreInput}
                                        value={this.state.informazioniSulCaso.comune}
                                        field={"comune"}
                                        placeholder={t("SchedaSpecialeEpatiteE.InformazioniSulCaso.comune")}
                                       suggestions={this.state.comuni}
                                    />

                                </div>
                            </div>
                            <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello2' : ''}`}>
                                <div className={styles.fieldContainer}>

                                    <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                        {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.cittadinanza")}
                                        <span className={styles.mandatoryColor}>*</span>
                                    </p>

                                    <Autocomplete id={"cittadinanza"}
                                                  keyField={"codice"}
                                                  descriptionField={"descrizione"}
                                                  suggestionField={"descrizione"}
                                                  onChange={this.riceviValoreInput}
                                                  field={"cittadinanza"}
                                                  placeholder={t("SchedaSpecialeEpatiteE.InformazioniSulCaso.cittadinanza")}
                                                 suggestions={this.state.nazioni}
                                                 value={this.state.informazioniSulCaso.cittadinanza}
                                    >
                                    </Autocomplete>
                                </div>
                            </div>

                            <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.anniItalia")}
                                </p>
                                <Input
                                    id={"anniItalia"}
                                   onChange={this.riceviValoreInput}
                                    field={"anniItalia"}
                                    min="0"
                                    type={"number"}
                                   disabled={this.state.informazioniSulCaso && this.state.informazioniSulCaso.cittadinanza && (!this.state.informazioniSulCaso.cittadinanza.codice || this.state.informazioniSulCaso.cittadinanza.codice === "100")}
                                    errorMessage={"sezione non valido"}
                                   value={this.state.informazioniSulCaso.anniItalia}
                                    placeholder={"Anni"}
                                >
                                </Input>
                            </div>
                        </div>

                        <div className="row">
                            <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello2' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.professione")}
                                </p>

                                <Autocomplete
                                    id={"professione"}
                                    onChange={this.riceviValoreInput}
                                    field={"professione"}
                                    value={this.state.informazioniSulCaso.professione}
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    placeholder={t("SchedaSpecialeEpatiteE.InformazioniSulCaso.professione")}
                                    suggestions={this.state.professioni}
                                    >
                                </Autocomplete>

                            </div>
                            <div className={`col-lg-7 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.InformazioniSulCaso.titoloStudio")}
                                </p>

                                <Select
                                    id={"titoloStudio"}
                                    value={this.state.informazioniSulCaso.titoloStudio}
                                   onChange={this.riceviValoreInput}
                                    functionMap={OggettiUtili.titoloStudio.map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                    })}>

                                </Select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
export default withTranslation('common')(InformazioniSulCaso)
